<script setup lang="ts">
import { type ScadenzarioElettorale } from "@gasparigit/omnia-sdk";

defineProps<{
  content: ScadenzarioElettorale;
  compact?: boolean;
  showAreas?: boolean;
}>();
</script>

<template>
  <FrontContentItemsBaseContent v-bind="$props">
    <template #info></template>
    <template #preview>
      <div class="font-monospace flex flex-col text-tertiary items-start justify-center font-semibold text-base me-2 mb-2 md:mb-0" v-if="content.election_date">
        <span class="text-3xl">{{ content.election_date.getDate() }}</span>
        <span>{{ content.election_date.toLocaleString("default", { month: "long" }) }}</span>
        <span>{{ content.election_date.getFullYear() }}</span>
      </div>
    </template>
  </FrontContentItemsBaseContent>
</template>
